import theme from 'common/styles/theme';
import i18n from 'i18next';

export const accountAnalyticsConstants = {
  GET_ACCOUNT_ANALYTICS_REQUEST: 'GET_ACCOUNT_ANALYTICS_REQUEST',
  GET_ACCOUNT_ANALYTICS_SUCCESS: 'GET_ACCOUNT_ANALYTICS_SUCCESS',
  GET_ACCOUNT_ANALYTICS_FAILURE: 'GET_ACCOUNT_ANALYTICS_FAILURE',
  GET_ACCOUNT_ANALYTICS_SUMMARY_REQUEST: 'GET_ACCOUNT_ANALYTICS_SUMMARY_REQUEST',
  GET_ACCOUNT_ANALYTICS_SUMMARY_SUCCESS: 'GET_ACCOUNT_ANALYTICS_SUMMARY_SUCCESS',
  GET_ACCOUNT_ANALYTICS_SUMMARY_FAILURE: 'GET_ACCOUNT_ANALYTICS_SUMMARY_FAILURE',
};

export const getAccountAnalyticsMetadata = (t = i18n.t.bind(i18n)) => ({
  measurements: {
    sortOrder: [
      'vibration',
      'pressure',
      'temperature',
      'current',
      'ultrasound',
      'utilization'
    ],
    colors: [theme.colors.green, theme.colors.yellow, theme.colors.red, theme.colors.pink, theme.colors.blue, theme.colors.greenXD],
    route: '/devices',
    title: t('accountAnalytics.charts.measurements', { defaultValue: 'Measurements' }),
    id: 'account-analytics-measurements',
    widgetType: 'DONUT_CHART'
  },
  channels: {
    sortOrder: [
      'Active Mote',
      'Active Tx',
      'Available Mote',
      'Available Tx'
    ],
    colors: [theme.colors.green, theme.colors.yellow, theme.colors.red, theme.colors.blue],
    route: '/devices',
    title: t('accountAnalytics.charts.channels', { defaultValue: 'Channels' }),
    id: 'account-analytics-channels',
    widgetType: 'DONUT_CHART'
  },
  tags: {
    sortOrder: [
      'Active',
      'Inactive'
    ],
    colors: [theme.colors.green, theme.colors.yellow],
    route: '/devices',
    title: t('accountAnalytics.charts.tags', { defaultValue: 'Tags' }),
    id: 'account-analytics-tags',
    widgetType: 'DONUT_CHART'
  }
});
